import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { LoadingSpinner } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import type { Ref } from 'react';
import useOnboardingKindText from '@/hooks/use-onboarding-kind-text';
import useStatusText from '@/hooks/use-status-text';
import { getStatusColor, getTimestampText, isAutomaticCheckOnboarding, onboardingHasPlaybook } from '../../../onboardings-shared/utils';
type OnboardingListItemProps = {
  onboarding: EntityOnboarding;
  isSelected: boolean;
  onClick: () => void;
  ref: Ref<HTMLButtonElement>;
};
const OnboardingListItem = t0 => {
  const $ = _c(42);
  const {
    onboarding,
    isSelected,
    onClick,
    ref
  } = t0;
  const statusT = useStatusText();
  const onboardingKindT = useOnboardingKindText();
  let t1;
  if ($[0] !== onboarding.status) {
    t1 = getStatusColor(onboarding.status);
    $[0] = onboarding.status;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusColor = t1;
  const t2 = statusColor === "success";
  const t3 = statusColor === "error";
  const t4 = statusColor === "neutral";
  let t5;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = cx("text-caption-3", {
      "text-success": t2,
      "text-error": t3,
      "text-tertiary": t4
    });
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const statusClassName = t5;
  const isPending = onboarding.status === "pending" && !onboarding.deactivated;
  let t6;
  if ($[6] !== isPending || $[7] !== onboarding) {
    t6 = isPending || !isAutomaticCheckOnboarding(onboarding) || onboarding.status === "error";
    $[6] = isPending;
    $[7] = onboarding;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const showStatus = t6;
  const t7 = isSelected ? "true" : undefined;
  const t8 = !isSelected;
  let t9;
  if ($[9] !== isSelected || $[10] !== t8) {
    t9 = cx("shrink-0 p-3 text-left border border-solid rounded cursor-pointer bg-primary", {
      "border-tertiary hover:border-primary": t8,
      "border-accent shadow-sm": isSelected
    });
    $[9] = isSelected;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== onboarding.timestamp) {
    t10 = getTimestampText(onboarding.timestamp);
    $[12] = onboarding.timestamp;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10) {
    t11 = <p className="text-snippet-3 text-tertiary">{t10}</p>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== isPending || $[17] !== onboarding.status || $[18] !== showStatus || $[19] !== statusClassName || $[20] !== statusT) {
    t12 = showStatus && <div className="flex items-center gap-1.5">{isPending && <LoadingSpinner size="compact" color="tertiary" />}<span className={statusClassName}>{statusT(onboarding.status)}</span></div>;
    $[16] = isPending;
    $[17] = onboarding.status;
    $[18] = showStatus;
    $[19] = statusClassName;
    $[20] = statusT;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <div className="flex items-center justify-between">{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== onboarding.kind || $[26] !== onboardingKindT) {
    t14 = onboardingKindT(onboarding.kind);
    $[25] = onboarding.kind;
    $[26] = onboardingKindT;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <div className="text-label-2 text-primary">{t14}</div>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== onboarding) {
    t16 = onboardingHasPlaybook(onboarding) && onboarding.playbook && <div className="text-label-2 text-tertiary line-clamp-1">{onboarding.playbook.name}</div>;
    $[30] = onboarding;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t13 || $[33] !== t15 || $[34] !== t16) {
    t17 = <div className="flex flex-col gap-1">{t13}{t15}{t16}</div>;
    $[32] = t13;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== onClick || $[37] !== ref || $[38] !== t17 || $[39] !== t7 || $[40] !== t9) {
    t18 = <button ref={ref} type="button" aria-current={t7} className={t9} onClick={onClick}>{t17}</button>;
    $[36] = onClick;
    $[37] = ref;
    $[38] = t17;
    $[39] = t7;
    $[40] = t9;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
};
export default OnboardingListItem;